import React from "react";
import { Grid } from "components/layout/Grid";
import { SubMenuContainerSimple } from "../../overlay/style";
import { SubMenu } from "../../overlay/sub-menus";

interface SubMenuContainerProps {
  hasOverlay: boolean;
}

const SubMenuContainer = ({ hasOverlay }: SubMenuContainerProps) => {
  return (
    <Grid>
      <SubMenuContainerSimple display={!hasOverlay ? "none" : "flex"}>
        <SubMenu />
      </SubMenuContainerSimple>
    </Grid>
  );
};

export default SubMenuContainer;
